module.exports = __webpack_public_path__ + "img/party_1_home-body.de53a0db.jpeg";